export default __webpack_public_path__ + "static/international-metric-mobile-3c5b9bd8c8a8e253c81cdc3da5306607.svg";